let transferIndex = 1000;

function transferIncrease() {
    transferIndex++;
}

export { transferIndex, transferIncrease };
